// extracted by mini-css-extract-plugin
export default {"balancesRow":"balances-row_balancesRow__Gik9z","box":"balances-row_box__lQd3r"};